import {withFormik} from "formik";
import * as yup from "yup"
import httpClient from "../../../services/httpClient";
import {usersApi} from "../../../constans/apiUrls";
import {TransactionWalletType} from "../../../constans/enumTypes";
import {INewTransactionWalletData} from "../../../contracts/data/user";
import InnerNewTransactionWalletUserForm
    from "../../../components/FormTemplates/user/InnerNewTransactionWalletUserForm";

const newTransactionWalletUserFormValidationSchema = yup.object().shape({
    amount: yup.number().required("مبلغ الزامی میباشد").min(10000, "حداقل مبلغ 10,000 ریال میباشد"),
    description: yup.string().required("توضیحات الزامی میباشد"),
})

interface INewTransactionWalletUserFormProps {
    userId: number,
    handleCloseModal: any
}

const NewTransactionWalletUserForm = withFormik<INewTransactionWalletUserFormProps, INewTransactionWalletData>({
    mapPropsToValues: props => ({
        amount: 0,
        type: TransactionWalletType.DEPOSIT,
        description: ""
    }),
    validationSchema: newTransactionWalletUserFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        await httpClient().put(`${usersApi.wallet_transactions}/${formikBag?.props?.userId}`, values)
            .then(response => {
                if(response.status === 201 ){
                    formikBag?.props?.handleCloseModal(response?.data?.data)
                    formikBag.setStatus({
                        ...formikBag.props,
                        result: response.data
                    })
                }
            })
            .catch(error => formikBag.setStatus({
                ...formikBag.props,
                result: error?.response?.data
            }))
    },
    displayName: 'NewTransactionWalletUserForm'
})(InnerNewTransactionWalletUserForm)

export default NewTransactionWalletUserForm